var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { extractCreatePayloadType } from "@hyper-hyper-space/hhs3_mvt";
import { kindFromType } from "./root_index.js";
export function readRootPayloads(backend) {
    return __awaiter(this, void 0, void 0, function* () {
        const dagEntries = yield backend.listDags();
        const roots = [];
        for (const entry of dagEntries) {
            const dag = yield backend.openDag(entry.id);
            if (dag === undefined)
                continue;
            const createEntry = yield dag.loadEntry(entry.id);
            if (createEntry === undefined)
                continue;
            const type = extractCreatePayloadType(createEntry.payload);
            if (type === undefined)
                continue;
            roots.push({ id: entry.id, type, payload: createEntry.payload });
        }
        return roots;
    });
}
export function rehydrateRoots(replica, backend, index) {
    return __awaiter(this, void 0, void 0, function* () {
        const roots = yield readRootPayloads(backend);
        for (const root of roots) {
            index.upsert({
                id: root.id,
                type: root.type,
                kind: kindFromType(root.type),
                name: payloadName(root.payload),
            });
        }
        const loaded = [];
        const loadable = [...roots].sort((a, b) => priority(a.type) - priority(b.type));
        const pending = new Set(loadable);
        let progressed = true;
        while (pending.size > 0 && progressed) {
            progressed = false;
            for (const root of [...pending]) {
                try {
                    const object = yield replica.createObject(root.payload);
                    root.object = object;
                    index.registerObject(root.id, object, payloadName(root.payload));
                    loaded.push(root);
                    pending.delete(root);
                    progressed = true;
                }
                catch (e) {
                    if (!isDependencyError(e))
                        throw e;
                }
            }
        }
        if (pending.size > 0) {
            const ids = [...pending].map((root) => `${root.id} (${root.type})`).join(', ');
            throw new Error(`Could not rehydrate roots with unresolved dependencies: ${ids}`);
        }
        return loaded;
    });
}
export function payloadName(payload) {
    if (typeof payload !== 'object' || payload === null || Array.isArray(payload))
        return undefined;
    const name = payload['name'];
    return typeof name === 'string' ? name : undefined;
}
function priority(type) {
    if (type === 'hhs/rschema_v1')
        return 0;
    if (type === 'hhs/rtable_group_v1')
        return 1;
    if (type === 'hhs/rdb_v1')
        return 2;
    return 3;
}
function isDependencyError(e) {
    const message = e instanceof Error ? e.message : String(e);
    return message.includes('is not present in the replica');
}
export function dagEntryFromRoot(root) {
    return { id: root.id, type: root.type, createdAt: 0 };
}
